module.exports = __webpack_public_path__ + "media/images/icons/vendors/large/caterers-c9010d5674a32a0028c7907e25f5bd40.png";